// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { RankedMenu } from '@jupyterlab/ui-components';
import { SemanticCommand } from '@jupyterlab/apputils';
/**
 * An extensible Run menu for the application.
 */
export class RunMenu extends RankedMenu {
    /**
     * Construct the run menu.
     */
    constructor(options) {
        super(options);
        this.codeRunners = {
            restart: new SemanticCommand(),
            run: new SemanticCommand(),
            runAll: new SemanticCommand()
        };
    }
}
//# sourceMappingURL=run.js.map